import { ComponentProps, useMemo } from 'react';
import { TextField, validators } from '@vst/beam';

interface AddressFieldInputProps extends ComponentProps<typeof TextField> {
  validation?: {
    required: string;
    invalid: string;
    regex: RegExp;
  };
}

const AddressFieldInput = (props: AddressFieldInputProps) => {
  const { validation, ...textFieldProps } = props;

  const validationRules = useMemo(() => {
    const validationRules = [];
    if (validation?.required) {
      validationRules.push(validators.required({ message: validation.required }));
    }
    if (validation?.invalid) {
      validationRules.push(validators.pattern({ pattern: validation.regex, message: validation.invalid }));
    }
    return validationRules;
  }, [validation]);

  return (
    <TextField
      data-testid={textFieldProps.name}
      labelProps={{ showStar: false }}
      validationRules={validationRules}
      required={!!validation?.required}
      {...textFieldProps}
    />
  );
};

export default AddressFieldInput;
